/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandZeit = createReactComponent("brand-zeit", "IconBrandZeit", [
  ["path", { d: "M3 20h18l-9 -16z", key: "svg-0" }]
]);

export { IconBrandZeit as default };
//# sourceMappingURL=IconBrandZeit.js.map
